import { render, staticRenderFns } from "./SettingComponent.vue?vue&type=template&id=11e2caca&"
import script from "./SettingComponent.vue?vue&type=script&lang=js&"
export * from "./SettingComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports